/**
 * Test IDs for QA automation.
 */
export const testIds = {
  businessEntityFormName: "business-entity-form-name",
  businessEntityFormEntityTypes: "business-entity-form-entity-types",
  businessEntityFormBusinessCode: "business-entity-form-business-code",
  businessEntityFormMc: "business-entity-form-mc",
  businessEntityFormFedId: "business-entity-form-fed-id",
  businessEntityFormScac: "business-entity-form-scac",
  businessEntityFormDot: "business-entity-form-dot",
  businessEntityFormShipmentDocumentsToReceiveToggle: "business-entity-form-shipment-documents-to-receive-toggle",
  businessEntityFormShipmentDocumentsToReceivePicker: "business-entity-form-shipment-documents-to-receive-picker",
  businessEntityFormShipmentDocumentsToReceiveSearch: "business-entity-form-shipment-documents-to-receive-search",
  businessEntityFormBillingEmailToggle: "business-entity-form-billing-email-toggle",
  businessEntityFormBillingEmailField: "business-entity-form-billing-email-field",
  businessEntityFormBillingTerms: "business-entity-form-billing-terms",
  businessEntityFormRemitAddressSameAsBilling: "business-entity-form-remit-address-same-as-billing",
  businessEntityFormSameAsBillingAddress: "business-entity-form-same-as-billing-address",
  businessEntityFormRemitCompanyName: "business-entity-form-remit-company-name",
  businessEntityFormRemitEmail: "business-entity-form-remit-email",
  businessEntityFormRemoveContact: "business-entity-form-remove-contact",
  businessEntityFormInventoryItemLabel: "business-entity-form-inventory-item-label",
  businessEntityFormWeight: "business-entity-form-weight",
  businessEntityFormRemoveInventoryItem: "business-entity-form-remove-inventory-item",
  businessEntityFormAddInventoryItem: "business-entity-form-add-inventory-item",
  businessEntityFormRemoveStorageFacility: "business-entity-form-remove-storage-facility",
  businessEntityFormImport: "business-entity-form-import",
  businessEntityFormNote: "business-entity-form-note",
  businessEntityFormAddToOrder: "business-entity-form-add-to-order",
  businessEntityFormRemoveNote: "business-entity-form-remove-note",
  businessEntityFormAddNote: "business-entity-form-add-note",
  businessEntityFormOpenDocument: "business-entity-form-open-document",
  businessEntityFormRemoveDocument: "business-entity-form-remove-document",
  businessEntityFormDocumentName: "business-entity-form-document-name",
  businessEntityFormRequiredForInvoicing: "business-entity-form-required-for-invoicing",
  businessEntityFormAttachToInvoice: "business-entity-form-attach-to-invoice",
  businessEntityFormAddDocumentRequirement: "business-entity-form-add-document-requirement",
  businessEntityFormSave: "business-entity-form-save",
} as const;
